(function() {
  var section = document.querySelector('[data-ghost-reviews]');
  if (!section) return;

  var track = section.querySelector('[data-ghost-reviews-track]');
  var slides = section.querySelectorAll('[data-ghost-reviews-slide]');
  var dots = section.querySelectorAll('[data-ghost-reviews-dot]');
  var prevButton = section.querySelector('[data-ghost-reviews-prev]');
  var nextButton = section.querySelector('[data-ghost-reviews-next]');
  var modal = section.querySelector('[data-ghost-reviews-modal]');
  var modalPanel = section.querySelector('.ghost-reviews-modal__panel');
  var modalTitle = section.querySelector('[data-ghost-reviews-modal-title]');
  var modalBody = section.querySelector('[data-ghost-reviews-modal-body]');
  var modalAuthor = section.querySelector('[data-ghost-reviews-modal-author]');
  var modalDate = section.querySelector('[data-ghost-reviews-modal-date]');
  var closeButtons = section.querySelectorAll('[data-ghost-reviews-modal-close]');
  var focus = window.GhostModalFocus;

  var currentIndex = 0;
  var timer = null;
  var autoplayMs = 4000;

  function goTo(index) {
    if (!slides.length) return;
    currentIndex = (index + slides.length) % slides.length;

    if (track) {
      track.style.transform = 'translateX(-' + currentIndex * 100 + '%)';
    }

    dots.forEach(function(dot, i) {
      dot.classList.toggle('is-active', i === currentIndex);
      dot.setAttribute('aria-current', i === currentIndex ? 'true' : 'false');
    });
  }

  function startAutoplay() {
    stopAutoplay();
    timer = window.setInterval(function() {
      goTo(currentIndex + 1);
    }, autoplayMs);
  }

  function stopAutoplay() {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
  }

  function openModal(trigger) {
    if (!modal || !modalTitle || !modalBody || !modalAuthor || !modalDate) return;

    modalTitle.textContent = trigger.getAttribute('data-modal-title') || '';
    modalBody.textContent = trigger.getAttribute('data-modal-body') || '';
    modalAuthor.textContent = trigger.getAttribute('data-modal-author') || '';
    modalDate.textContent = trigger.getAttribute('data-modal-date') || '';

    if (focus) focus.rememberFocus();
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    stopAutoplay();
    if (focus) focus.focusInitial(modalPanel, '[data-ghost-reviews-modal-close]');
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (focus) focus.restoreFocus();
    startAutoplay();
  }

  if (prevButton) {
    prevButton.addEventListener('click', function() {
      goTo(currentIndex - 1);
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', function() {
      goTo(currentIndex + 1);
    });
  }

  dots.forEach(function(dot, index) {
    dot.addEventListener('click', function() {
      goTo(index);
    });
  });

  section.querySelectorAll('[data-ghost-review-trigger]').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      openModal(trigger);
    });
  });

  closeButtons.forEach(function(button) {
    button.addEventListener('click', closeModal);
  });

  if (modal) {
    modal.addEventListener('click', function(event) {
      if (event.target === modal) closeModal();
    });
  }

  document.addEventListener('keydown', function(event) {
    if (modal && !modal.hidden) {
      if (event.key === 'Escape') {
        closeModal();
        return;
      }

      if (focus) focus.trapTab(event, modalPanel);
      return;
    }

    if (event.key === 'ArrowLeft') goTo(currentIndex - 1);
    if (event.key === 'ArrowRight') goTo(currentIndex + 1);
  });

  section.addEventListener('mouseenter', stopAutoplay);
  section.addEventListener('mouseleave', startAutoplay);
  section.addEventListener('focusin', stopAutoplay);
  section.addEventListener('focusout', function(event) {
    if (!section.contains(event.relatedTarget)) startAutoplay();
  });

  goTo(0);
  startAutoplay();
})();
